/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DataChartBarsAIcon16Light } from './DataChartBarsAIcon16Light';
import { DataChartBarsAIcon16Regular } from './DataChartBarsAIcon16Regular';
import { DataChartBarsAIcon16Solid } from './DataChartBarsAIcon16Solid';
import { DataChartBarsAIcon20Light } from './DataChartBarsAIcon20Light';
import { DataChartBarsAIcon20Regular } from './DataChartBarsAIcon20Regular';
import { DataChartBarsAIcon20Solid } from './DataChartBarsAIcon20Solid';
import { DataChartBarsAIcon24Regular } from './DataChartBarsAIcon24Regular';
import { DataChartBarsAIcon24Solid } from './DataChartBarsAIcon24Solid';
import { DataChartBarsAIcon32Regular } from './DataChartBarsAIcon32Regular';
import { DataChartBarsAIcon64Regular } from './DataChartBarsAIcon64Regular';
var sizes = {
    16: {
        light: DataChartBarsAIcon16Light,
        regular: DataChartBarsAIcon16Regular,
        solid: DataChartBarsAIcon16Solid,
    },
    20: {
        light: DataChartBarsAIcon20Light,
        regular: DataChartBarsAIcon20Regular,
        solid: DataChartBarsAIcon20Solid,
    },
    24: {
        regular: DataChartBarsAIcon24Regular,
        solid: DataChartBarsAIcon24Solid,
    },
    32: {
        regular: DataChartBarsAIcon32Regular,
    },
    64: {
        regular: DataChartBarsAIcon64Regular,
    },
};
export var DataChartBarsAIcon = forwardRef('DataChartBarsAIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
